import { render, staticRenderFns } from "./PaymentMethodList.vue?vue&type=template&id=0f871536"
import script from "../../controllers/payment_method/payment-method-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_method/payment-method-list.js?vue&type=script&lang=js&external"
import style0 from "./PaymentMethodList.vue?vue&type=style&index=0&id=0f871536&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports